export const h = {
    "common": {
        "webSuffix": "QIDI Tech",
        "email": "poštovní schránka",
        "password": "heslo",
        "verificationCode": "Ověřovací kód",
        "username": "uživatelské jméno",
        "readAndAgree": "Souhlasím",
        "and": "a",
        "userAgreement": "Uživatelská smlouva",
        "privacyPolicy": "Zásady ochrany osobních údajů",
        "copy": "autorská práva ©  Od 2025 si Di vyhrazuje vlastnictví",
        "sendVerificationCode": "Odeslat ověřovací kód",
        "Sending": "Odesílání",
        "tryAgainInSeconds": "Zkus to znovu během vteřin.",
        "userNameRequired": "zadejte jedno uživatelské jméno",
        "passwordInputLabel": "Zadejte prosím heslo",
        "checkPasswordInputLabel": "Zadejte prosím potvrzovací heslo",
        "userEmailRequired": "Zadejte prosím svou e-mailovou adresu",
        "userEmailInvalid": "Zadejte prosím správnou e-mailovou adresu",
        "emailCodeRequired": "Zadejte prosím ověřovací kód",
        "newPasswordInputLabel": "Zadejte prosím nové heslo",
        "confirmPasswordInputLabel": "Zadejte prosím heslo znovu",
        "passwordMismatchErrorLabel": "Heslo zadané dvakrát není konzistentní",
        "agreementRequired": "Přečtěte si prosím tuto smlouvu a souhlasíte s ní",
        "tip": "Tipy",
        "tipAlreadyLogin": "Zjistili jste, že jste se přihlásili, přesměrovali do uživatelského centra pro vás",
        "tipWelcomeBack": "Vítejte zpět~",
        "tipDeleteAccountFail": "Nepodařilo se odstranit účet, rozhraní pro odstranění účtu je dočasně uzavřeno",
        "pleaseAgreeFirst": "Prosím, nejdřív souhlasíme.",
        "agree": "souhlasit",
        "refuse": "odmítnout",
        "tipNeedLogin": "Prosím, nejdřív se přihlaste.",
        "tipChangePasswordSuccess": "Heslo změněno úspěšně, přesměrujeme vás na přihlašovací stránku",
        "tipGetUserInfoSuccess": "Úspěšně získané informace",
        "tipGetUserInfoFail": "selhání informací",
        "tipLoginOut": "Odhlásit se a přihlásit se",
        "delete": "smazat",
        "back": "vrátit",
        "init": "inicializace",

        "passwordInputLengthErrorLabel": "Délka hesla by měla být mezi 6 a 20",
        "changePasswordFail": "Původní heslo nesprávné",
        "tipDeleteAccountSuccess": "Účet úspěšně smazán",
        "emailCodeSentSuccess": "Ověřovací kód byl vydán",
        "emailCodeSentFail": "Vydání ověřovacího kódu selhalo",
        "emailLoginFail": "Ověřovací kód vypršel",
        "passwordLoginFail": "Přihlašovací heslo nesprávné",
        "editUserInfoSuccess": "Úspěšně upravené uživatelské informace",
        "registerSuccess": "úspěšně registrována",
        "registerFail": "přihlášení selhalo",
        "registerEmailExistFail": "Email již existuje",

        "resMessageTip0": "neznámé informace",
        "resMessageTip1": "Chyba hesla",
        "resMessageTip2": "Délka hesla by měla být mezi 6 a 20",
        "resMessageTip3": "Chyba účtu",
        "resMessageTip4": "Ověřovací kód byl vydán",
        "resMessageTip5": "Vydání ověřovacího kódu selhalo",
        "resMessageTip6": "Ověřovací kód vypršel",
        "resMessageTip7": "Chyba hesla",
        "resMessageTip8": "Heslo nemůže být stejné jako staré heslo",
        "resMessageTip9": "Email již existuje",
        "resMessageTip10": "úspěšně registrována",
        "resMessageTip11": "přihlášení selhalo",
        "resMessageTip12": "Úspěšně upravené uživatelské informace",
        "resMessageTip13": "Nepodařilo se změnit uživatelské informace",
        "resMessageTip14": "Úspěšně získané",
        "resMessageTip15": "Získání selhalo",
        "resMessageTip16": "Heslo změněno úspěšně",
        "resMessageTip17": "Změna hesla selhala",
        "resMessageTip18": "Obnovení hesla úspěšné",
        "resMessageTip19": "Obnovení hesla selhalo",
        "resMessageTip20": "Přihlášení úspěšné",
        "resMessageTip21": "Přihlášení selhalo",
        "resMessageTip22": "Účet úspěšně smazán",
        "resMessageTip23": "Nepodařilo se smazat účet",
        "resMessageTip24": "Ověřovací kód je nesprávný",
        "noUserInfoError": "Chyba sítě, přihlaste se prosím znovu"
    },
    "changePassword": {
        "newPassword": "Nové heslo"
    },
    "deleteUser": {
        "tipDeleteUser": "Bohužel musíte odejít. Jakmile bude váš účet smazán, všechny vaše osobní údaje trvale zmizí a nelze je obnovit.",
        "accountDeletionTerms": "Podmínky vymazání účtu"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Získat heslo prostřednictvím e-mailu",
        "confirmPassword": "Potvrdit heslo",
        "resettingPassword": "resetovat heslo",
        "resetting": "Obnovit"
    },
    "login": {
        "passwordLogin": "Přihlášení hesla",
        "verifyLogin": "Ověřit přihlášení",
        "accountRegistration": "Registrace účtu",
        "forgotPassword": "Zapomněl jsem heslo",
        "login": "Přihlásit se",
        "localLogin": "Místní přihlášení",
        "loginOut": "Odhlásit se",
        "continueOnYourWay": "Pokračujte v cestě."
    },
    "register": {
        "registerAnAccount": "Zaregistrovat účet",
        "register": "registrovat"
    },
    "userCenter": {
        "personalInformation": "osobní údaje",
        "modifyInformation": "Upravit informace",
        "changePassword": "Změnit heslo",
        "cancelAccount": "Zrušit účet",
        "exitAccount": "Ukončit účet",
        "change": "upravit",
        "maxCharLimitTip": "Délka uživatelského jména nesmí překročit deset čínských znaků",
    },
    "policies": {
        "deleteAccountPrivacy": "Smazat smlouvu o účtu",
        "agreement": "Smlouva o použití",
        "privacyPolicy": "Zásady ochrany osobních údajů"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Vyberte si zemi nebo oblast",
        "recommendedVisits": "Doporučená návštěva",
        "NorthAmerica": "Severní Amerika",
        "Europe": "Evropa",
        "Asia": "Asie",
        "Other": "ostatní",
    }
}


export const aAndL ={
    "ar": {
        "Country": "arabská",
        "Language": "Arabština"
    },
    "cs": {
        "Country": "Česká republika",
        "Language": "Čeština"
    },
    "de": {
        "Country": "Německo",
        "Language": "Němčina"
    },
    "en": {
        "Country": "Británie",
        "Language": "angličtina"
    },
    "es": {
        "Country": "Španělsko",
        "Language": "Španělština"
    },
    "fr": {
        "Country": "Francie",
        "Language": "Francouzština"
    },
    "he": {
        "Country": "Izrael",
        "Language": "Hebrejština"
    },
    "hu": {
        "Country": "Maďarsko",
        "Language": "Maďarština"
    },
    "it": {
        "Country": "Itálie",
        "Language": "Italština"
    },
    "ja": {
        "Country": "Japonsko",
        "Language": "Japonština"
    },
    "ko": {
        "Country": "Korejská republika",
        "Language": "Korejština"
    },
    "nl": {
        "Country": "Nizozemsko",
        "Language": "Nizozemština"
    },
    "pt": {
        "Country": "Portugalsko",
        "Language": "Portugalština"
    },
    "pt_BR": {
        "Country": "Portugalsko (Brazílie)",
        "Language": "Portugalština (Brazílie)"
    },
    "ru": {
        "Country": "Rusko",
        "Language": "ruština"
    },
    "sv": {
        "Country": "Švédsko",
        "Language": "Švédský jazyk"
    },
    "tr": {
        "Country": "Türkiye",
        "Language": "Turecky"
    },
    "uk": {
        "Country": "Ukrajina",
        "Language": "Ukrajinský jazyk"
    },
    "zh": {
        "Country": "Čínská pevnina",
        "Language": "Zjednodušená čínština"
    },
    "zh_tw": {
        "Country": "Tchaj-wan, Čína",
        "Language": "Tradiční čínština"
    },
    "Canada": {
        "Country": "Kanada",
        "Language": "angličtina"
    },
    "United_States": {
        "Country": "USA",
        "Language": "angličtina"
    },
    "United_Kingdom": {
        "Country": "Británie",
        "Language": "angličtina"
    },
    "EU_Countries": {
        "Country": "Země EU",
        "Language": "angličtina"
    },
    "Australia": {
        "Country": "Austrálie",
        "Language": "angličtina"
    },
    "globalzh": {
        "Country": "Globální",
        "Language": "Zjednodušená čínština"
    },
    "globalen": {
        "Country": "Global",
        "Language": "angličtina"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/cs.js